import { Redirect, Route, Switch } from "react-router-dom";
import { routes } from "../routes";

const Auth = () => {
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <>
      <div className="auth-main-content">
        <Switch>
          {getRoutes(routes)}
          <Redirect from="*" to="/auth/signup" />
        </Switch>
      </div>
    </>
  );
};

export default Auth;
